import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import SplashPage from './SplashPage';

const RootRoute = () => {
  const { isAuthenticated, loading, currentUser, onboardingStatus } = useAuth();

  // Show loading spinner while authentication or onboarding status is being checked
  if (loading || (isAuthenticated && onboardingStatus.loading)) {
    return (
      <div className="d-flex justify-content-center align-items-center" style={{ height: '100vh' }}>
        <div className="spinner-border text-primary" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    );
  }

  // If authenticated, redirect based on onboarding completion
  if (isAuthenticated) {
    if (currentUser?.registration_profile_completed === false) {
      return <Navigate to="/register" replace />;
    }

    const welcomeFlowDone =
      onboardingStatus.profileComplete && onboardingStatus.waitlistHandoffComplete;

    if (currentUser?.is_waitlisted) {
      return welcomeFlowDone
        ? <Navigate to="/waitlist" replace />
        : <Navigate to="/welcome" replace />;
    }

    return !welcomeFlowDone ? <Navigate to="/welcome" replace /> : <Navigate to="/dashboard" replace />;
  }

  // If not authenticated, show splash page
  return <SplashPage />;
};

export default RootRoute;
